declare var $: JQueryStatic;
declare var sDiffSetting: GameVariationCodes;

import 'core-js/actual'

import { SudokuGame } from './sudokuGame';

import PersonalStats, { FormattedStats } from './personalStats';
import { logError } from './utils';


const ignoredErrorMessageRegex = /(AbortError|lngtdv|imasdk)/;
// Set up global error tracking
window.addEventListener('unhandledrejection', function (event) {
    if (ignoredErrorMessageRegex.test(event.reason)) {
        // ignoring this message. Likely an ads error
        return;
    }
    logError(new Error(event.reason));
});
window.onerror = function (msg, url, line) {
    const newMessage = msg + " at " + url + " line " + line
    if (ignoredErrorMessageRegex.test(newMessage)) {
        // ignoring this message. Likely an ads error
        return;
    }
    logError(new Error(newMessage));
}

let personalStats: PersonalStats
let diffSetting: GameKeyEnum;
//Show the statistics link on the main game pages and wire up personal stats
$(() => {
    // Set up personal stats
    diffSetting = getGameVariation(sDiffSetting)?.title as GameKeyEnum;
    personalStats = new PersonalStats(window.IsLoggedIn);
    personalStats.getFormattedStats(diffSetting).then((stats) => {
        updatePersonalStatsModal(stats);
    });
    $("#stat-nav").show()
    $(".resetStats").on("click", (e) => {
        e.preventDefault()
        const confirmed = confirm("Are you sure you want to reset your stats?");
        if (confirmed) {
            personalStats.clear(diffSetting);
            personalStats.getFormattedStats(diffSetting).then((stats) => {
                updatePersonalStatsModal(stats);
            });
        }
    })
})

//stopwatch variables
var SWsec = -1;
var SWmin = 0;
var SWhour = 0;
var SWStopwatchRunning = false;
var stopwatchTimeoutID;
let solverUsed = false;
let gameStarted = false;
let iCurNum = 0;

const gameVariations = [
    {
        code: 'E',
        title: 'Easy',
        displayTitle: 'Easy'
    },
    {
        code: 'M',
        title: 'Medium',
        displayTitle: 'Medium'
    },
    {
        code: 'H',
        title: 'Hard',
        displayTitle: 'Hard'
    },
    {
        code: 'V',
        title: 'Tough',
        displayTitle: 'Expert'
    },
    {
        code: 'U',
        title: 'Evil',
        displayTitle: 'Evil'
    },
    {
        code: 'A',
        title: 'Easy 4x4',
        displayTitle: 'Easy 4x4'
    },
    {
        code: 'B',
        title: 'Hard 4x4',
        displayTitle: 'Hard 4x4'
    },
    {
        code: 'C',
        title: 'Easy 6x6',
        displayTitle: 'Easy 6x6',

    },
    {
        code: 'D',
        title: 'Hard 6x6',
        displayTitle: 'Hard 6x6',

    },
    {
        code: 'Y',
        title: '16x16',
        displayTitle: '16x16',
    },
    {
        code: 'P',
        title: 'Parents',
        displayTitle: 'Parents',
    },
] as const;

type GameVariationCodes = typeof gameVariations[number]['code'];
type GameInfo = {
    code: GameVariationCodes,
    title: GameKeyEnum,
    displayTitle: string
}

function getGameVariation(diffSetting: GameVariationCodes): GameInfo {
    return gameVariations.find(function (val) {
        return val.code == diffSetting
    });
}


/**
 * @type {SudokuGame}
 */
let theGame;


function KeyGet(e) {
    const keycode = e.which;
    return String.fromCharCode(keycode);
}

function XBrowserAddHandler(target, eventName, handlerName) {
    if (target.addEventListener) {
        target.addEventListener(eventName, function (e) { target[handlerName](e); }, false);
    } else if (target.attachEvent) {
        target.attachEvent("on" + eventName, function (e) { target[handlerName](e); });
    } else {
        var originalHandler = target["on" + eventName];
        if (originalHandler) {
            target["on" + eventName] = function (e) {
                originalHandler(e);
                target[handlerName](e);
            };
        } else {
            target["on" + eventName] = target[handlerName];
        }
    }
}

function XBrowserAddHNoCM(target, eventName, handlerName) {
    if (target.addEventListener) {
        target.addEventListener(eventName, function (e) { target[handlerName](e); }, false);
    } else if (target.attachEvent) {
        target.attachEvent("on" + eventName, function (e) { target[handlerName](e); return false });
    } else {
        var originalHandler = target["on" + eventName];
        if (originalHandler) {
            target["on" + eventName] = function (e) {
                originalHandler(e);
                target[handlerName](e);
            };
        } else {
            target["on" + eventName] = target[handlerName];
        }
    }
}

function IsKeyOK(sChar) {
    var sOKChars = '1234567890ABCDEFG';
    sChar = sChar.toUpperCase();
    if (sOKChars.indexOf(sChar) == -1)
        return false;
    else return true;
}


function IsClear(oControl: HTMLTableCellElement) {
    if (oControl.innerHTML.toUpperCase() == '&NBSP;' || oControl.innerHTML == ' ')
        return true;
    else if (oControl.innerHTML.length > 0) {
        if (oControl.innerHTML.charCodeAt(0) == 160)
            return true;
        else return false;
    } else
        return false;
}

function CurNumSelect(e) {
    var iNewNum;
    if (this.innerHTML.toUpperCase().indexOf("<B>") == -1) {
        if (IsClear(this) == true)
            iNewNum = 0;
        else
            iNewNum = this.innerHTML;
        MoveNum(iNewNum);
    }
}

function MoveNum(iNewNum) {
    if (iNewNum == iCurNum)
        return true;

    var oNumCtl;

    oNumCtl = document.getElementById('Num' + iCurNum);
    oNumCtl.bgColor = '';
    if (iCurNum == 0)
        oNumCtl.innerHTML = '&nbsp;';
    else
        oNumCtl.innerHTML = iCurNum;


    iCurNum = iNewNum;
    theGame.activeNumber = iCurNum.toString();
    theGame.updateGameBoardUI();
    const checkUsedNumbers: HTMLInputElement | null = document.getElementById("GreyUsedNumbers") as HTMLInputElement;
    if (checkUsedNumbers?.checked == true)
        CheckUsedNumbers();
    else SetCurrentNum();
}

/**
 * Return The "HEX" value. But this isn't really hex, because it actually has 17 numbers 0 - 9 and A-G
 * @param {number} iTestNum - The number 0 - 16
 * @returns {string | number} hex value of the number
 */
function NumToHex(iTestNum) {
    if (iTestNum > 9)
        return String.fromCharCode(iTestNum + 55);
    else
        return iTestNum;
}

/**
 * Highlight which number is currently being used
 */
function SetCurrentNum() {
    const oNumCtl: any = document.getElementById('Num' + iCurNum);
    if (oNumCtl && oNumCtl.innerHTML.toUpperCase() != '&NBSP;') {
        oNumCtl.innerHTML = '<b>' + iCurNum + '</b>';
        if (oNumCtl.bgColor == '') {
            oNumCtl.bgColor = sSqMarkColor;
        }
    }

}

window.ShowFullSolution = function ShowFullSolution() {

    const btnFullSol: HTMLInputElement = document.getElementById('btnFullSol') as HTMLInputElement;
    if (btnFullSol?.value == 'Show Solution') {
        btnFullSol.value = 'Hide Solution';
        theGame.showSolution = true;
        $("#choose-number-text").hide()
        $("#showPrize-button").show()

        theGame.updateGameBoardUI();
    } else {
        btnFullSol.value = 'Show Solution';
        $("#choose-number-text").show()
        $("#showPrize-button").hide()
        theGame.showSolution = false;
        theGame.updateGameBoardUI();
    }
}

/**
 * Hides the full solution if it is being shown.
 * If the full solution is not being shown, do nothing
 */
function HideFullSolution() {
    const btnFullSol: HTMLInputElement = document.getElementById('btnFullSol') as HTMLInputElement;
    if (btnFullSol?.value == 'Show Solution') {
        return;
    }
    btnFullSol.value = 'Show Solution';
    theGame.showSolution = false;
    theGame.updateGameBoardUI();
}

/**
 * Sets the style of the table cell element. Depending of if possibilities are on or not.
 * @param {HTMLTableCellElement} oCtl
 * @param {boolean} bPossibilityOn
 */
function TDSettings(oCtl, bPossibilityOn) {
    if (bPossibilityOn == true) {
        oCtl.style.textAlign = 'right';
        oCtl.vAlign = 'top';
    } else {
        oCtl.style.textAlign = 'center';
        oCtl.vAlign = 'center';
    }
}

function ResetBoard() {
    HideFullSolution();
    theGame.reset();
    theGame.updateGameBoardUI();
    resetIt(); //resets stopwatch

}
window.ResetBoard = ResetBoard;

/**
 * Reset all possbilities
 */
function ResetPoss() {
    theGame.resetPossibilities();
    theGame.updateGameBoardUI();
}

window.ResetPoss = ResetPoss;

/**
 * Check if there are any errors in the current game
 */
window.CheckForErrors = function CheckForErrors() {
    if (!theGame.hasErrors()) {
        alert('All moves so far are correct.');
    } else {
        if (confirm('Some numbers were incorrect.\n\nWould you like to see which ones?')) {
            var oldSetting = theGame.showIncorrectMoves;
            theGame.showIncorrectMoves = true;
            theGame.updateGameBoardUI();
            theGame.showIncorrectMoves = oldSetting;
        }
    }
}
var completed = false;
async function CheckIsComplete() {
    if (completed) {
        return;
    }
    if (theGame.isComplete()) {
        completed = true;
        $("#choose-number-text").hide()
        $("#showPrize-button").show()
        var sTime;

        if (SWStopwatchRunning == true) {
            sTime = " Your time was " + document.getElementsByClassName('TimerTime')[0].innerHTML;
            const timeInSeconds = SWhour * 3600 + SWmin * 60 + parseInt(SWsec as any);
            (document.getElementById('Timer_SecondsTaken') as any).value = timeInSeconds;
            Pause();
            var $congratsTime = $("#congratsTime");
            $congratsTime.text(sTime);
            $congratsTime.show();
            const gameKey = getGameVariation(sDiffSetting)?.title as GameKeyEnum;
            if (!solverUsed) {
                await personalStats.winGame(gameKey, timeInSeconds)
            }

        } else {
            sTime = '';
        }
        ShowPrize();
    }
}

/**
 * See if there are any errors in the current solution
 */
function CheckMoves() {
    if (theGame.hasErrors()) {
        if (confirm('Some numbers were incorrect.\n\nWould you like to see which ones?')) {
            theGame.showIncorrectMoves = true;
            theGame.updateGameBoardUI()
            theGame.showIncorrectMoves = false;
        }
    } else {
        alert('All moves so far are correct.')
    }
}

function HexToNum(sHex) {
    var sHexChars;
    sHexChars = "ABCDEFG";
    if (sHexChars.indexOf(sHex) > -1)
        return (sHex.charCodeAt(0) - 55);
    else
        return parseInt(sHex);
}
/**
 * Grey out any of the numbers that have been completely used.
 * @returns True
 */
function CheckUsedNumbers() {

    if ((document.getElementById("GreyUsedNumbers") as HTMLInputElement).checked == false)
        return true;

    const usedNumbers = theGame.checkUsedNumbers();

    theGame.validInputs.forEach((val) => {

        const id = `Num${val}`
        const el = document.getElementById(id) as any
        if (usedNumbers.includes(val)) {
            el.bgColor = sBGColor
        } else {
            el.bgColor = ''
        }
    })
    SetCurrentNum();
}

function keyCodeToDirection(keyCode) {
    switch (keyCode) {
        case 37:
            return "left";
        case 38:
            return "up";
        case 39:
            return "right";
        case 40:
            return "down";
    }
}

function shouldInterceptArrowKeys() {
    var currentFocus = document.activeElement
    // Not sure when this occurs, but just to be safe do nothing
    if (!currentFocus) {
        return false;
    }
    // Use the arrow keys if the user is focused on one of the game play controls
    // or the general body
    if (currentFocus.id == "sudokutable" ||
        currentFocus.id == "PossibilityMode" ||
        currentFocus.id == "btnUndo" ||
        currentFocus.className.indexOf("Numbertable") > -1
    ) {
        return true;
    }

    return false;
}

/**
 * Handles a keydown event
 * @param {keydown Event} e
 * @returns
 */
function KeyboardPlaceNumber(e) {
    var iNewNum;
    var sChar;
    // If the user hits the escape key put focus on the body of the page
    const possMode = document.getElementById('PossibilityMode') as HTMLInputElement;
    if (e.keyCode == 27 && shouldInterceptArrowKeys()) {
        const el = document.activeElement
        if ((el as any).blur) {
            (el as any).blur()
        }

        return true;
    }
    // clear the cell on backspace and delete
    if (e.keyCode == 8 || e.keyCode == 46) {
        if (!shouldInterceptArrowKeys()) {
            return;
        }
        var cellId = theGame.activeCell && theGame.activeCell.id;
        theGame.clearCell(cellId);
        theGame.updateGameBoardUI();
        return true;
    }

    // On spacebar toggle the possibility mode
    if (e.keyCode == 32 && shouldInterceptArrowKeys()) {
        e.preventDefault();
        possMode.checked = !possMode.checked;
        handlePossibilityModeChange();
        return true;
    }

    // Check if the key pressed is an arrow key
    if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {

        // Don't handle the arrow keys if the user is in the comments form or some other
        // non-game input device
        if (!shouldInterceptArrowKeys()) {
            return;
        }

        // Move the active cell in the direction of the key pressed
        var direction = keyCodeToDirection(e.keyCode);
        theGame.moveActiveCell(direction);
        e.preventDefault();
        theGame.updateGameBoardUI();
        return true;
    }
    sChar = KeyGet(e);
    sChar = sChar.toUpperCase();
    if (!theGame.isValidInput(sChar))
        return true;

    iNewNum = sChar;
    MoveNum(iNewNum)
    PlaceNumber(possMode.checked);
}


/**
 * Handle a Left Click from the mouse on the playing board
 * @param {any} e - Seems unused
 * @returns true if a number has already been placed here
 */
function MousePlaceNumber(e) {
    // get the cell id from the element
    const cellId = getCellIndex(this);
    theGame.setActiveCell(cellId);

    const placeMovesWithMouse = document.getElementById("PlaceMovesWithMouse") as HTMLInputElement
    const possMode = document.getElementById("PossibilityMode") as HTMLInputElement;
    // Place the number if the user has PlaceMovesWithMouse
    if (placeMovesWithMouse.checked == true) {
        PlaceNumber(possMode.checked);
    } else {
        theGame.updateGameBoardUI()
    }
}

/**
 * Add the current number to the specified cell as a guess or add it as a possibliity if bPossModeChecked is true.
 * @param {boolean} bPossModeChecked - true if the current number is being entered as a possibility
 */
function PlaceNumber(bPossModeChecked) {
    // don't place a number if there is no active cell selected
    if (theGame.activeCell == null) {
        return;
    }
    const allowIncorrectMoves = document.getElementById('AllowIncorrectMoves') as HTMLInputElement
    theGame.allowIncorrectMoves = allowIncorrectMoves.checked
    theGame.saveUndo()
    // start the timer if it hasn't already been started
    if (!SWStopwatchRunning) {
        stopwatch("Start");
    }
    const cellId = theGame.activeCell.id;
    if (iCurNum == 0) {
        theGame.clearCell(cellId);
    } else if (!bPossModeChecked) {
        theGame.addGuess(cellId, iCurNum)
    } else {
        theGame.togglePossibility(cellId, iCurNum)
    }

    if (!gameStarted) {
        const gameVariation = getGameVariation(sDiffSetting);
        personalStats.startGame(gameVariation?.title as GameKeyEnum);
        gameStarted = true;
    }

    CheckUsedNumbers();
    theGame.updateGameBoardUI();
    CheckIsComplete()
}


function MouseMoveRC(evt) {

    // get the cell id from the element
    const cellId = getCellIndex(this);
    theGame.setActiveCell(cellId);

    if (!document.all) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    const placeMovesWithMouse = document.getElementById("PlaceMovesWithMouse") as HTMLInputElement;
    if (placeMovesWithMouse.checked == true)
        PlaceNumber(true);

}

function handlePossibilityModeChange() {
    const $checkbox = $("#PossibilityMode")[0] as HTMLInputElement;
    if ($checkbox.checked) {
        $("#sudokutable").addClass("possibility-mode");
    } else {
        $("#sudokutable").removeClass("possibility-mode");
    }
}

/**
 * Sets up the initial starting position for the game.
 * Wires up event clickHandlers for game actions.
 */
window.PlayInit = function PlayInit() {

    Math.sqrt(iGridSolved.length)
    theGame = new SudokuGame(Math.sqrt(iGridSolved.length), iGridSolved, iGridUnsolved);
    // Set default values
    theGame.possibilitiesInGrid = (document.getElementById("GridPossibilities") as HTMLInputElement).checked
    theGame.automaticallyRemovePossibilities = (document.getElementById("RemovePossibilties") as HTMLInputElement).checked
    theGame.showIncorrectMoves = !(document.getElementById("AllowIncorrectMoves") as HTMLInputElement).checked
    theGame.highlightActiveNumber = (document.getElementById("HighlightActiveNumber") as HTMLInputElement).checked
    theGame.highlightActiveCell = (document.getElementById("HighlightCurrSquare") as HTMLInputElement).checked

    // Set up keyboard listener
    $(document).keydown(KeyboardPlaceNumber);
    if (bEnterYourOwnPuzzle == true)
        document.getElementById('btnLockNumbers').style.display = '';

    iCurNum = 0;
    MoveNum(1);

    var iC;
    var oControl;
    // Wire up curNumSelect for each of the number buttons
    for (iC = 0; iC <= (document.getElementById('sudokutable') as HTMLTableElement).rows.length; iC++) {
        oControl = document.getElementById('Num' + NumToHex(iC));
        oControl.ClickHandler = CurNumSelect;
        XBrowserAddHandler(oControl, "click", "ClickHandler");
    }
    // Add additional event handlers
    $("#showPrize-button").on("click", function (e) {
        e.preventDefault();
        var sTime;
        if (SWStopwatchRunning == true) {
            sTime = " Your time was " + document.getElementsByClassName('TimerTime')[0].innerHTML;
            (document.getElementById('Timer_SecondsTaken') as any).value = SWhour * 3600 + SWmin * 60 + parseInt(SWsec as any);
            Pause();
        } else {
            sTime = '';
        }
        ShowPrize();
    })
    $("#PossibilityMode").change(function () {
        handlePossibilityModeChange();
    })

    // Fill in the starting numbers for the game
    // Wire up left and right click handlers.
    for (iC = 0; iC < iGridUnsolved.length; iC++) {
        oControl = document.getElementById('T' + iC);
        const gameCell = theGame.cells[iC]
        gameCell.answer = iGridSolved[iC]
        if (iGridUnsolved[iC] != 0) {
            theGame.cells[iC].isGiven = true;
            theGame.cells[iC].addGuess(iGridSolved[iC]);
        }

        oControl.ClickHandler = MousePlaceNumber;
        XBrowserAddHandler(oControl, "click", "ClickHandler");
        oControl.RCClickHandler = MouseMoveRC;
        XBrowserAddHNoCM(oControl, "contextmenu", "RCClickHandler");

    }

    // Save the users settings. This allows us to change the default settings and not change the behavior of the
    // game for long time users
    window.SetDefaults();

    theGame.updateGameBoardUI()

    // Attempt to migrate the local stats to the server
    if (window.IsLoggedIn && window.migrateStats) {
        personalStats.migrateStats();
    }
}

function monthname() {
    var months = new Array(13);
    months[0] = "January";
    months[1] = "February";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";
    return months[(sTodaysDate.split('-')[1] as any) - 1];
}

function SetCellSize(oCtl, iSize) {
    var iX;
    var iY;

    for (iX = 0; iX <= oCtl.rows.length - 1; iX++) {
        for (iY = 0; iY <= oCtl.rows.length - 1; iY++) {
            oCtl.rows[iY].cells[iX].height = iSize + 'px';
        }
    }
}

function getCookieVal(offset) {
    var endstr = document.cookie.indexOf(";", offset);
    if (endstr == -1)
        endstr = document.cookie.length;
    return unescape(document.cookie.substring(offset, endstr));
}

function GetCookie(name, DefaultVal) {
    var arg = name + "=";
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;
    while (i < clen) {
        var j = i + alen;
        if (document.cookie.substring(i, j) == arg)
            return getCookieVal(j);
        i = document.cookie.indexOf(" ", i) + 1;
        if (i == 0) break;
    }
    return DefaultVal;
}

function SetCookie(name, value, expires?, path?, domain?, secure?) {
    var argv = SetCookie.arguments;
    var argc = SetCookie.arguments.length;
    var expires = (argc > 2) ? argv[2] : null;
    var path = (argc > 3) ? argv[3] : null;
    var domain = (argc > 4) ? argv[4] : null;
    var secure = (argc > 5) ? argv[5] : false;
    document.cookie = name + "=" + escape(value) +
        ((expires == null) ? "" : ("; expires=" + expires.toGMTString())) +
        ((path == null) ? "" : ("; path=" + path)) +
        ((domain == null) ? "" : ("; domain=" + domain)) +
        ((secure == true) ? "; secure" : "");
}



window.SetDefaults = function SetDefaults() {
    var expdate = new Date();
    expdate.setTime(expdate.getTime() + (24 * 60 * 60 * 1000 * 31));

    const RemovePossibilties = (document.getElementById("RemovePossibilties") as HTMLInputElement).checked
    const AllowIncorrectMoves = (document.getElementById("AllowIncorrectMoves") as HTMLInputElement).checked
    const PlaceMovesWithMouse = (document.getElementById("PlaceMovesWithMouse") as HTMLInputElement).checked
    const HighlightCurrSquare = (document.getElementById("HighlightCurrSquare") as HTMLInputElement).checked
    const HighlightActiveNumber = (document.getElementById("HighlightActiveNumber") as HTMLInputElement).checked
    const GreyUsedNumbers = (document.getElementById("GreyUsedNumbers") as HTMLInputElement).checked
    const GridPossibilities = (document.getElementById("GridPossibilities") as HTMLInputElement).checked

    const OptionsMenuOpen = $("#optionsList").hasClass("expanded");

    if (theGame) {
        theGame.automaticallyRemovePossibilities = RemovePossibilties
        theGame.showIncorrectMoves = !AllowIncorrectMoves
        theGame.possibilitiesInGrid = GridPossibilities
        theGame.highlightActiveNumber = HighlightActiveNumber
        theGame.highlightActiveCell = HighlightCurrSquare
        theGame.updateGameBoardUI()
    }

    if (OptionsMenuOpen) {
        openOptions();
    }
    SetCookie("ckRemovePossibilties", RemovePossibilties, expdate);
    SetCookie("ckAllowIncorrectMoves", AllowIncorrectMoves, expdate);
    SetCookie("ckPlaceMovesWithMouse", PlaceMovesWithMouse, expdate);
    SetCookie("ckHighlightCurrSquare", HighlightCurrSquare, expdate);
    SetCookie("ckHighlightActiveNumber", HighlightActiveNumber, expdate);
    SetCookie("ckGreyUsedNumbers", GreyUsedNumbers, expdate);
    SetCookie("ckGridPossibilities", GridPossibilities, expdate);
    SetCookie("ckOptionsMenuOpen", OptionsMenuOpen, expdate);

    var oCtl;
    var iHeight;
    oCtl = document.getElementById('sudokutable');

    switch (oCtl.height) {
        case '360':
        case '360px':
            iHeight = 270
            break;

        case '324':
        case '324px':
            iHeight = 360
            break;

        case '270':
        case '270px':
            iHeight = 324
            break;

        case '640':
        case '640px':
            iHeight = 640
            break;
    }
    SetCookie("iTableHeight", iHeight, expdate);
}
/**
 * Updates Gameplay Settings based on user cookies
 */
window.ReadDefaults = function ReadDefaults() {

    (document.getElementById("RemovePossibilties") as HTMLInputElement).checked = (GetCookie("ckRemovePossibilties", "false") == "true");
    (document.getElementById("AllowIncorrectMoves") as HTMLInputElement).checked = (GetCookie("ckAllowIncorrectMoves", "false") == "true");
    (document.getElementById("PlaceMovesWithMouse") as HTMLInputElement).checked = (GetCookie("ckPlaceMovesWithMouse", "true") == "true");
    (document.getElementById("HighlightCurrSquare") as HTMLInputElement).checked = (GetCookie("ckHighlightCurrSquare", "true") == "true");
    (document.getElementById("HighlightActiveNumber") as HTMLInputElement).checked = (GetCookie("ckHighlightActiveNumber", "true") == "true");
    (document.getElementById("GreyUsedNumbers") as HTMLInputElement).checked = (GetCookie("ckGreyUsedNumbers", "true") == "true");
    (document.getElementById("GridPossibilities") as HTMLInputElement).checked = (GetCookie("ckGridPossibilities", "true") == "true");
    (document.getElementById('sudokutable') as any).height = GetCookie("iTableHeight", "270px");

    let optionsOpenCookieVal = GetCookie("ckOptionsMenuOpen", "false");
    if (optionsOpenCookieVal == "true") {
        openOptions();
    }

}

function SaveGame() {

    var SBoard = theGame.serialize()
    var expdate = new Date();
    expdate.setTime(expdate.getTime() + (24 * 60 * 60 * 1000 * 7));


    const curTime = SWhour * 3600 + SWmin * 60 + parseInt(SWsec as any);

    SetCookie(sDiffSetting + sSourceName + "_SavedBoard", SBoard, expdate);
    SetCookie(sDiffSetting + sSourceName + "_SavedTime", curTime, expdate);
    alert("The current Game has been saved.");

}
window.SaveGame = SaveGame;


function LoadGame() {
    var sBoard;

    // If a user loads the game, then mark the game as already started,
    // so we don't double count the games played.
    gameStarted = true;

    sBoard = GetCookie(sDiffSetting + sSourceName + "_SavedBoard", "NoSave");
    const savedTime = GetCookie(sDiffSetting + sSourceName + "_SavedTime", "NoSave");
    if (sBoard == "NoSave") {
        alert("There is no saved game for this puzzle (clearing cookies will erase saved games).");
        return true;
    }
    if (savedTime != "NoSave") {
        SWhour = Math.floor(savedTime / 3600);
        SWmin = Math.floor((savedTime - SWhour * 3600) / 60);
        SWsec = savedTime - SWhour * 3600 - SWmin
        stopwatch("Start");
    }

    theGame.restoreGame(sBoard)
    CheckUsedNumbers();
    theGame.updateGameBoardUI()
}
window.LoadGame = LoadGame;
/**
 * For paying users, allows them to save their game.
 */
function SaveTime() {
    (document.getElementById('Timer_SaveTime') as HTMLInputElement).value = "SaveMyTime";
    (document as any).Form1.submit();
}
window.SaveTime = SaveTime;

function updatePersonalStatsModal(stats: FormattedStats) {
    const displayTitle = getGameVariation(sDiffSetting)?.displayTitle;
    $(".congratsModalDifficulty").text(displayTitle);
    $('.statsGames').text(stats.games)
    $('.statsWins').text(stats.wins)
    $('.statsWinPct').text(stats.winPercentage)
    $('.statsFastestTime').text(stats.fastestTimeFormatted)
    $('.statsAverageTime').text(stats.averageTimeFormatted)

}

/**
 * Show the end of game modal
 */
function ShowPrize() {

    // For supporting members allow them to save their time
    if (IsSupportingMember == true && (document.getElementById('Timer_SecondsTaken') as any).value != 0) {
        $("#saveTimeButton").show()
    }
    personalStats.getFormattedStats(diffSetting).then((stats) => {
        updatePersonalStatsModal(stats);
        ($("#congratsModal") as any).modal("show");

        // Google Ads conversion tracking

        if (typeof gtag !== 'undefined') {
            gtag('event', 'conversion', {
                'send_to': 'AW-1036966941/84LQCK2d9-0aEJ24u-4D',
                'value': 1.0,
                'currency': 'USD',
            });

        }
    });

}

/**
 * Gets the numeric index of the cell from its id
 * @param {HTMLElement} cell
 * @returns {number}
 */
function getCellIndex(cell) {
    let id = cell.id;
    return parseInt(id.replace("T", ""));
}

function ShareGame() {
    var sBoard;
    sBoard = theGame.serialize();
    (document.getElementById("ShareStuff") as any).style.display = 'inline';
    (document.getElementById("txtShareStuffCode") as HTMLInputElement).value = sBoard;
}

function LoadSharedGame() {
    var sBoard;
    sBoard = (document.getElementById("txtShareStuffCode") as HTMLInputElement).value;
    theGame.restoreGame(sBoard);
    (document.getElementById("ShareStuff") as any) .style.display = 'none';
}

/**
 * Saves the state of the game
 * Notes:
 * UndoesCurr - is a number which keeps track of the current length of the undos
 * Undos - An array which keeps a list of stringified versions of each game state
 */
window.SaveUndo = function SaveUndo() {
    alert("Undos not working correctly")
}

window.LoadUndo = function LoadUndo() {
    if (theGame.hasUndos()) {
        theGame.undo();
        theGame.updateGameBoardUI();
    } else {
        alert('No moves have been made');
    }
}

window.Hint = function Hint() {
    const hint = theGame.hint();
    if (hint) {
        const theCell = theGame.getCell(hint.id)
        theCell.isHint = true;
        theGame.updateGameBoardUI();
        theCell.isHint = false;
    } else {
        alert("Sorry, I can't help you. Too tough for me!");
    }
}


function SolveEasy() {
    if (theGame.hasErrors()) {
        alert("Some moves are incorrect. I can't solve until the board is in a valid state")
    } else {
        solverUsed = true;
        theGame.solve();
        theGame.replacePossibilitiesWithSolverPossibilities();
        theGame.updateGameBoardUI();
        alert("OK, I've solved all I can.");
        CheckIsComplete()
    }

}
window.SolveEasy = SolveEasy;



function stopwatch(text?: string) {
    SWsec++;
    if (SWsec == 60) {
        SWsec = 0;
        SWmin = SWmin + 1;
    } else {
        SWmin = SWmin;
    }
    if (SWmin == 60) {
        SWmin = 0;
        SWhour += 1;
    }

    if (SWsec <= 9) { (SWsec as any) = "0" + SWsec; }
    var newTime = ((SWhour <= 9) ? "0" + SWhour : SWhour) + ":" + ((SWmin <= 9) ? "0" + SWmin : SWmin) + ":" + SWsec;
    document.querySelectorAll('.TimerTime')[0].innerHTML = newTime;

    if (text == "Start") {
        SWStopwatchRunning = true;
        hideStartButton();
    }
    if (text == "Pause") {
        SWStopwatchRunning = false;
        hidePauseButton()
        Pause();
        return true;
    }

    stopwatchTimeoutID = window.setTimeout(stopwatch, 1000);
}
window.stopwatch = stopwatch;

function Pause() {
    SWStopwatchRunning = false;
    window.clearTimeout(stopwatchTimeoutID);
    SWsec = SWsec - 1;
    hidePauseButton();
}

function hidePauseButton() {
    for (var x = 0; x < document.querySelectorAll('.TimerTime').length; x++) {
        document.querySelectorAll('.TimerTime')[x].className = 'TimerTime me-2';
        document.querySelectorAll('.TimerPause')[x].className = "TimerPause me-1 d-none";
        document.querySelectorAll('.TimerStart')[x].className = "TimerStart me-1 btn btn-primary btn-xs";
    }
}

function hideStartButton() {
    for (var x = 0; x < document.querySelectorAll('.TimerTime').length; x++) {
        document.querySelectorAll('.TimerTime')[x].className = 'TimerTime me-2 active';
        document.querySelectorAll('.TimerPause')[x].className = "TimerPause me-1 btn btn-primary btn-xs";
        document.querySelectorAll('.TimerStart')[x].className = "TimerStart me-1 d-none";
    }
}

function resetIt() {
    SWStopwatchRunning = false;
    SWsec = -1;
    SWmin = 0;
    SWhour = 0;
    document.querySelectorAll('.TimerTime')[0].innerHTML = "00:00:00";
    hidePauseButton();

    window.clearTimeout(stopwatchTimeoutID);
}

function ButtonsDisable16x16() {
    var oButton;
    oButton = document.getElementById('btnSolveEasy');
    if (oButton)
        oButton.disabled = true;

    oButton = document.getElementById('btnHint');
    if (oButton)
        oButton.disabled = true;

    oButton = document.getElementById('btnScreen');
    if (oButton)
        oButton.disabled = true;
}
window.ButtonsDisable16x16 = ButtonsDisable16x16;


window.HandleNoImage = function HandleNoImage() {
    // There is no prize picture today
    $("#congratsImage").html("")
}

/**
 * Sets the prize image to be shown at the end of the game.
 * This method is triggered from within PlayGridTop.txt
 */
function LoadPrizeImage() {
    // This uses the value inserted onto the window with REPLACEMEWITHPRIZEPICNAME.
    document.addEventListener("DOMContentLoaded", function () {
        let prizePicName = `Prizes/${window.SUDOKU_GLOBAL.prizePicName}.jpg`;
        if (window.SUDOKU_GLOBAL.env == "local") {
            prizePicName = `https://dev.sudokubliss.com/${prizePicName}`;
        }
        const html = `<img id='PrizePic' onerror=HandleNoImage() src="${prizePicName}" style="width: 80%">`
        $("#congratsImage").html(html)
        $("#congratsCaption").text(sPrizeCaption)

        var diffInfo = gameVariations.find((diff) => diff.code == sDiffSetting);
        if (diffInfo) {
            $("#congratsButtonLabel").text(diffInfo.title)
        }
        $("#congratsPlayAnotherLink").attr("href", window.SUDOKU_GLOBAL.random)

        if (window.SUDOKU_GLOBAL.otherGames) {
            const dropDownItems = window.SUDOKU_GLOBAL.otherGames.map((game) => {
                return `<a class="dropdown-item" href="${game.href}">${game.title}</a >`
            }).join("");
            $("#otherGamesDropdown").html(dropDownItems);
        }
    });
}
window.LoadPrizeImage = LoadPrizeImage
LoadPrizeImage();

function openOptions() {
    $("#optionsList").removeClass('contracted').addClass('expanded');
    $('#optionsHeader').find('.triangle').removeClass('triangleSide').addClass('triangleDown');
}

function closeOptions() {
    $("#optionsList").removeClass('expanded').addClass('contracted');
    $('#optionsHeader').find('.triangle').removeClass('triangleDown').addClass('triangleSide');
}


function PrintPuzzle(bWithSolution) {
    var sAllText;
    var bSmallGrid;
    let gridSmallElement =  document.getElementById('gridsize_small') as HTMLInputElement;
    if (!gridSmallElement) {
        return
    }
    bSmallGrid = gridSmallElement.checked;
    sDiffSetting == 'E';
    let sStyle = "<style> div {font-family:Verdana,Arial, Helvetica, sans-serif; font-size:11px; }	table.sudokutable {BORDER-COLLAPSE: collapse; width:100%;height:100%; cellSpacing:1; cellPadding:1 ;text-align:center}	.bdr00 {width:11%;border-top:2px solid black; border-bottom:1px solid black;border-left:2px solid black; border-right:1px solid black}	.bdr10 {width:11%;border-top:2px solid black; border-bottom:1px solid black;border-left:1px solid black; border-right:1px solid black}	.bdr20 {width:11%;border-top:2px solid black; border-bottom:1px solid black;border-left:1px solid black; border-right:2px solid black}	.bdr01 {width:11%;border-top:1px solid black; border-bottom:1px solid black;border-left:2px solid black; border-right:1px solid black}	.bdr11 {width:11%;border-top:1px solid black; border-bottom:1px solid black;border-left:1px solid black; border-right:1px solid black}	.bdr21 {width:11%;border-top:1px solid black; border-bottom:1px solid black;border-left:1px solid black; border-right:2px solid black}	.bdr02 {width:11%;border-top:1px solid black; border-bottom:2px solid black;border-left:2px solid black; border-right:1px solid black}	.bdr12 {width:11%;border-top:1px solid black; border-bottom:2px solid black;border-left:1px solid black; border-right:1px solid black}	.bdr22 {width:11%;border-top:1px solid black; border-bottom:2px solid black;border-left:1px solid black; border-right:2px solid black}		</style>";
    let sHeader = `<div style='width:100%;text-align:center'><b> ${getGameVariation(sDiffSetting).title} Sudoku for ${sTodaysDate} </b><br><br>`;

    sAllText = sStyle;
   
    sAllText = sAllText + sHeader;
    if (bSmallGrid == true)
        sAllText = sAllText + ' <div style=width:330px;height:300px>' + sUnsolvedSudoku + '</div>';
    else
        sAllText = sAllText + '<style> div#LargePrint table tr td { font-size:30px } </style> <div id=LargePrint style=' + String.fromCharCode(39) + 'width:530px;height:500px' + String.fromCharCode(39) + '>' + sUnsolvedSudoku + '</div>';

    if (bWithSolution == true) {
        if (bSmallGrid == true)
            sAllText = sAllText + '<div style=height:100px>&nbsp;</div><div style=width:330px;height:300px>' + sSolvedSudoku + '</div>';
        else
            sAllText = sAllText + '<div style=height:100px>&nbsp;</div><div style=width:200px;height:200px>' + sSolvedSudoku + '</div>';

    }
    sAllText = sAllText + '</div>';
    let Win1 = window.open('', '_Blank');
    if (Win1) {
        Win1.document.open();
        Win1.document.writeln(sAllText);
        Win1.document.close();
    }
}
window.PrintPuzzle = PrintPuzzle;


document.addEventListener("DOMContentLoaded", function () { //not using .ready() because jQuery loads in footer.
    $('#optionsHeader').on('click', function () {
        if ($("#optionsList").hasClass('expanded')) {
            closeOptions();

        } else {
            openOptions();
        }
        window.SetDefaults();
    });

    // Get references to the button and message elements
    const holdButton = document.getElementById("TimerReset") as HTMLInputElement;
    const message = document.getElementById("resetMessage") as HTMLInputElement;

    // Define the hold duration in milliseconds
    const holdDuration = 1000; // 2 seconds
    let holdTimeout;

    function triggerResetMessage() {
        if (message) {

            $(message).html("Hold to reset.<div id='resetAnimation'></div>");
            $(message).show();
            // Start a timeout when the button is pressed
            holdTimeout = setTimeout(() => {
                $(message).find("text").html("");
                $(message).hide();
                resetIt();

            }, holdDuration);
        }
    }
    // Add event listeners for mouse down, mouse up, and mouse leave
    holdButton.addEventListener("mousedown", () => {
        triggerResetMessage();
    });

    holdButton.addEventListener("mouseup", () => {
        clearTimeout(holdTimeout); // Clear the timeout if the button is released
        $(message).hide();

    });

    holdButton.addEventListener("mouseleave", () => {
        clearTimeout(holdTimeout); // Clear the timeout if the mouse leaves the button
        $(message).hide();
    });

    holdButton.addEventListener("touchstart", (e) => {
        e.preventDefault();
        triggerResetMessage();
    });

    holdButton.addEventListener("touchend", (e) => {
        e.preventDefault();
        clearTimeout(holdTimeout);
        $(message).hide();
    });

});
